/**
 * Given anchor date + last-reminder-at + interval, return the ISO date on
 * which the next automated reminder is expected to fire.
 * Returns null if there's no meaningful anchor date.
 */
export function nextReminderDate({ anchor, lastRemindedAt, intervalDays }) {
  if (!intervalDays || intervalDays < 1) return null;
  const base = lastRemindedAt || anchor;
  if (!base) return null;
  const d = new Date(String(base).slice(0, 10));
  if (Number.isNaN(d.getTime())) return null;
  d.setDate(d.getDate() + Number(intervalDays));
  return d.toISOString().slice(0, 10);
}

/**
 * RFQ nudge fires N days *before* the valid_until date (not after it), so
 * the formula is different from invoice/quotation.
 */
export function nextRfqNudgeDate({ validUntil, remindedAt, nudgeDays }) {
  if (remindedAt || !validUntil || !nudgeDays) return null;
  const d = new Date(String(validUntil).slice(0, 10));
  if (Number.isNaN(d.getTime())) return null;
  d.setDate(d.getDate() - Number(nudgeDays));
  return d.toISOString().slice(0, 10);
}

/** "in 3 days" / "yesterday" / "today" — short human hint for UI chips. */
export function relativeDayHint(iso) {
  if (!iso) return "";
  const target = new Date(String(iso).slice(0, 10));
  const today = new Date(new Date().toISOString().slice(0, 10));
  if (Number.isNaN(target.getTime())) return "";
  const diff = Math.round((target - today) / (24 * 3600 * 1000));
  if (diff === 0) return "today";
  if (diff === 1) return "tomorrow";
  if (diff === -1) return "yesterday";
  if (diff > 0) return `in ${diff}d`;
  return `${-diff}d ago`;
}
